/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PayoutDeductionItemResponse } from './PayoutDeductionItemResponse';
import type { PayoutDetailExpertResponse } from './PayoutDetailExpertResponse';
import type { PayoutTransactionItemResponse } from './PayoutTransactionItemResponse';
export type PayoutDetailResponse = {
    id: string;
    payoutNumber: string;
    expert: PayoutDetailExpertResponse;
    payoutMonth: string;
    totalEarnings: string;
    platformCommission: string;
    totalDeductions: string;
    disputesCount: number;
    disputesAmount: string;
    netPayout: string;
    status: string;
    holdReason?: Record<string, any>;
    /**
     * Date until which the payout is held
     */
    holdUntil?: Record<string, any>;
    releasedBy?: Record<string, any>;
    createdAt: string;
    /**
     * When funds reached the expert bank account
     */
    bankSettledAt?: Record<string, any>;
    /**
     * Reason if bank payout failed
     */
    bankFailureReason?: Record<string, any>;
    /**
     * Which payout rail this row runs on
     */
    payoutMethod: PayoutDetailResponse.payoutMethod;
    /**
     * Bank transfer reference (manual rail only)
     */
    bankReferenceNumber?: Record<string, any>;
    holdPlacedAt?: Record<string, any>;
    holdReleasedAt?: Record<string, any>;
    releasedAt?: Record<string, any>;
    payoutTransactionId?: Record<string, any>;
    /**
     * Connected-account destination payment ID
     */
    stripePayoutId?: Record<string, any>;
    nextPayoutDate?: Record<string, any>;
    transactions: Array<PayoutTransactionItemResponse>;
    deductions: Array<PayoutDeductionItemResponse>;
    previousPayouts: Array<Record<string, any>>;
    expertTransactions: Array<Record<string, any>>;
    displayMeta: Record<string, any>;
    expertInformation: Record<string, any>;
    paymentFinancials: Record<string, any>;
    nextPayout: Record<string, any>;
    transactionHistory: Record<string, any>;
};
export namespace PayoutDetailResponse {
    /**
     * Which payout rail this row runs on
     */
    export enum payoutMethod {
        STRIPE_CONNECT = 'stripe_connect',
        MANUAL_BANK = 'manual_bank',
    }
}

